import { createApi } from "@reduxjs/toolkit/query/react";
import { IPost } from "./postApiData";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

interface IDraftCountResponse {
  count: number;
}

export const draftsApi = createApi({
  reducerPath: "draftsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Draft"],
  endpoints: (build) => ({
    getDraftsCount: build.query<IDraftCountResponse, void>({
      query: () => ({
        url: "/posts/drafts/count",
      }),
      providesTags: [{ type: "Draft", id: "COUNT" }],
      keepUnusedDataFor: 0,
    }),

    getDrafts: build.query<IPost[], { page?: number; limit?: number; type?: string }>({
      query: ({ page = 1, limit = 20, type = "posts" } = {}) => ({
        url: "/posts/drafts",
        params: { page, limit, type },
      }),
      transformResponse: (response: { data: IPost[] }) => response.data,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ uid }) => ({ type: "Draft" as const, id: uid })),
              { type: "Draft", id: "LIST" },
            ]
          : [{ type: "Draft", id: "LIST" }],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetDraftsCountQuery, useGetDraftsQuery, useLazyGetDraftsQuery } = draftsApi;
